import React from 'react';
import { useUser } from '@lore/auth';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import Form from './Form';
import { Helmet } from 'react-helmet-async';
import useRouter from '../../../hooks/useRouter';
import useSetupNavigation from '../useSetupNavigation';
import useRoles from '../../../hooks/useRoles';
import useIntents from '../../../hooks/useIntents';

export default function Layout(props) {
  const { history } = useRouter();
  const user = useUser();

  const navigation = useSetupNavigation(Urls.PARTNER_INTENT);

  const { isClassroomTeacher } = useRoles();
  const { isEducator, isPartner } = useIntents();

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Partner Intent</title>
      </Helmet>
      <Form
        user={user}
        navigation={navigation}
        // onPrevious={(newData) => history.push(Urls.ZIP_CODE)}
        // onNext={(newData) => history.push(Urls.NAME)}
        // onSkip={() => history.push(Urls.NAME)}
        onPrevious={(newData) =>
          (isEducator && isClassroomTeacher) ? history.push(Urls.PAST_ENGAGEMENT) :
          isEducator ? history.push(Urls.SCHOOL) :
          history.push(Urls.EDUCATOR_INTENT_ORGANIZATION)
        }
        onNext={() => history.push(Urls.PARTNER_VALUE)}
        onSkip={() => history.push(Urls.EXPERIENCE)}
      />
    </ParentLayout>
  );
};
